module.exports = __webpack_public_path__ + "static/media/AI3.5d5485c9.jpeg";